<template>
  <div class="div" v-if="generatedReport">
    <div class="form border">
      <div class="row p-3">
        <a-spin :spinning="status === 'generating'" v-if="generatedReport">
          <div class="report-header">
            Budget (Start Date:
            {{ moment(generatedReport.start_date).format("MM/DD/YYYY") }} - End
            Date: {{ moment(generatedReport.end_date).format("MM/DD/YYYY") }})
          </div>
          <div class="report-container">
            <div class="chart-container">
              <div class="chart">
                <div class="chart-header">Logins by Platform</div>
                <div class="graph">
                  <report-graph
                    chartId="chart-1"
                    v-if="generatedReport.loginsByPlatform.loginsbyplatformlist"
                    :chartData="
                      generatedReport.loginsByPlatform.loginsbyplatformlist
                    "
                  ></report-graph>
                </div>
                <div
                  class="chart-data"
                  v-if="generatedReport.loginsByPlatform.loginsbyplatformlist"
                >
                  <div
                    class="chart-row"
                    v-for="device in generatedReport.loginsByPlatform
                      .loginsbyplatformlist"
                    :key="device.name"
                  >
                    <span>{{ device.name }}</span>
                    <span>{{ device.count }}</span>
                    <span>{{ device.percentage.toFixed(2) }}%</span>
                  </div>
                  <div class="chart-row total">
                    <span>Total Logins</span>
                    <span>{{
                      generatedReport.loginsByPlatform.total_count
                    }}</span>
                    <span
                      >{{
                        generatedReport.loginsByPlatform.total_percentage.toFixed(
                          2
                        )
                      }}%</span
                    >
                  </div>
                </div>
              </div>
              <div class="chart">
                <div class="chart-header">Orders by Platform</div>
                <div class="graph">
                  <report-graph
                    chartId="chart-2"
                    v-if="generatedReport.ordersByPlatform.ordersbyplatformlist"
                    :chartData="
                      generatedReport.ordersByPlatform.ordersbyplatformlist
                    "
                  ></report-graph>
                </div>
                <div
                  class="chart-data"
                  v-if="generatedReport.ordersByPlatform.ordersbyplatformlist"
                >
                  <div
                    class="chart-row"
                    v-for="device in generatedReport.ordersByPlatform
                      .ordersbyplatformlist"
                    :key="device.name"
                  >
                    <span>{{ device.name }}</span>
                    <span>{{ device.count }}</span>
                    <span>{{ device.percentage.toFixed(2) }}%</span>
                  </div>
                  <div class="chart-row total">
                    <span>Total Orders</span>
                    <span>{{
                      generatedReport.ordersByPlatform.total_count
                    }}</span>
                    <span
                      >{{
                        generatedReport.ordersByPlatform.total_percentage.toFixed(
                          2
                        )
                      }}%</span
                    >
                  </div>
                </div>
              </div>
              <div class="chart">
                <div class="chart-header">
                  Users Who Placed Orders by Platform
                </div>
                <div class="graph">
                  <report-graph
                    chartId="chart-3"
                    v-if="
                      generatedReport.usersWhoPlacedOrdersByPlatform
                        .userswhoplacedordersbyplatformlist
                    "
                    :chartData="
                      generatedReport.usersWhoPlacedOrdersByPlatform
                        .userswhoplacedordersbyplatformlist
                    "
                  ></report-graph>
                </div>
                <div
                  class="chart-data"
                  v-if="
                    generatedReport.usersWhoPlacedOrdersByPlatform
                      .userswhoplacedordersbyplatformlist
                  "
                >
                  <div
                    class="chart-row"
                    v-for="device in generatedReport
                      .usersWhoPlacedOrdersByPlatform
                      .userswhoplacedordersbyplatformlist"
                    :key="device.name"
                  >
                    <span>{{ device.name }}</span>
                    <span>{{ device.count }}</span>
                    <span>{{ device.percentage.toFixed(2) }}%</span>
                  </div>
                  <div class="chart-row total">
                    <span>Total Users Who Placed Orders</span>
                    <span>{{
                      generatedReport.usersWhoPlacedOrdersByPlatform.total_count
                    }}</span>
                    <span
                      >{{
                        generatedReport.usersWhoPlacedOrdersByPlatform.total_percentage.toFixed(
                          2
                        )
                      }}%</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ReportGraph from "./ReportGraph.vue";
export default {
  name: "P4pReport",
  components: { ReportGraph },
  data() {
    return {};
  },
  methods: {},
  computed: {
    authorizedClients() {
      return this.$store.getters["loginDashboard/getAuthorizedClients"];
    },
    status() {
      return this.$store.getters["loginDashboard/getStatus"];
    },
    generatedReport() {
      return this.$store.getters["loginDashboard/getGeneratedReport"];
    },
  },
};
</script>

<style lang="scss" scoped>
.border {
  border-radius: 5px;
}

.page-heading {
  font-size: 20px;
  font-weight: 500;
}
.report-header {
  text-align: center;
  font-size: 1.5em;
  font-weight: 700;
}
.chart-container {
  display: flex;
  flex-wrap: wrap;
  .chart {
    flex-basis: 42%;
    min-height: 400px;
    margin: 2% 4%;
    .chart-header {
      text-align: center;
      font-size: 1.2em;
      font-weight: 500;
    }
    .graph {
      min-height: 300px;
      min-width: 300px;
      & > div {
        display: flex;
        justify-content: center;
      }
    }
    .chart-data {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-height: 320px;
      overflow-y: auto;
      .chart-row {
        display: flex;
        width: 80%;
        justify-content: space-between;
        padding: 2% 0%;
        border-bottom: 0.5px solid #f2f2f2;
        &.total {
          font-weight: 500;
        }
        span:nth-child(1) {
          flex-basis: 50%;
        }
      }
    }
  }
}
</style>
